import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

type TPayload = {
	NotificationIds: Array<number>;
	Read: boolean;
};

export const { thunk: updateNotificationReadStatus, slice: notificationReadStatus } = getThunkAndSlice<TPayload, true>({
	initialState: true,
	path: "/api/Notifications/UpdateNotificationReadStatus",
	method: "post",
});
